import React from "react";
import { useSimulationStore } from "../../store/simulationStore";
import { useSettingsStore } from "../../store/settingsStore";
import type { PerformanceMode, SimulationPrecisionMode } from "../../types/astronomy";

export function SimulationModeControl() {
  const precisionMode = useSimulationStore((s) => s.precisionMode);
  const setPrecisionMode = useSimulationStore((s) => s.setPrecisionMode);
  const performanceMode = useSettingsStore((s) => s.performanceMode);
  const setPerformanceMode = useSettingsStore((s) => s.setPerformanceMode);

  return (
    <div className="tls-astro-control-block">
      <label htmlFor="tls-astro-precision">Modo de precisão</label>
      <select
        id="tls-astro-precision"
        value={precisionMode}
        onChange={(e) =>
          setPrecisionMode(e.target.value as SimulationPrecisionMode)
        }
      >
        <option value="kepler">Kepler (aproximado / offline)</option>
        <option value="ephemeris">Efemérides (estrutura + fallback)</option>
      </select>

      <label htmlFor="tls-astro-perf">Desempenho</label>
      <select
        id="tls-astro-perf"
        value={performanceMode}
        onChange={(e) =>
          setPerformanceMode(e.target.value as PerformanceMode)
        }
      >
        <option value="quality">Qualidade</option>
        <option value="balanced">Equilibrado</option>
        <option value="performance">Desempenho</option>
      </select>
    </div>
  );
}
